import React from 'react';
import PropTypes from 'prop-types';

import { Badge } from 'react-bootstrap';
import { css, StyleSheet } from 'aphrodite';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function TagBadge({ tag, onRemove, variant = 'secondary' }) {
  return (
    <Badge variant={variant} className={css(styles.badge)}>
      <span className={css(styles.tagText)}>{tag}</span>
      {onRemove && (
        <FontAwesomeIcon
          icon={faTimes}
          className={css(styles.removeIcon)}
          onClick={e => {
            e.stopPropagation();
            onRemove(tag);
          }}
        />
      )}
    </Badge>
  );
}

const styles = StyleSheet.create({
  badge: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    padding: '4px 8px',
    fontSize: 12,
    fontWeight: 500,
    marginRight: 4,
    marginBottom: 4,
    cursor: 'default',
  },
  tagText: {
    lineHeight: 1,
  },
  removeIcon: {
    fontSize: 10,
    cursor: 'pointer',
    opacity: 0.7,
    ':hover': {
      opacity: 1,
    },
  },
});

TagBadge.propTypes = {
  tag: PropTypes.string.isRequired,
  onRemove: PropTypes.func,
  variant: PropTypes.string,
};

export default TagBadge;
